import React from "react";
import tapestryImage from '../../images/tapis.JPG';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function TapisseriePage() {
    const seo = CATEGORIES_SEO.tapisserie;
    const details = [
        "Tapis Persans (Safavides) – 16e-17e siècles : Motifs floraux complexes, couleurs riches (rouge, bleu, or), qualité exceptionnelle de tissage.",
        "Tapis Turcs (Ottomans) – 15e-17e siècles : Motifs géométriques, couleurs vives et contrastées, influence ottomane.",
        "Tapis Caucasiens – 18e-19e siècles : Motifs géométriques, couleurs primaires, tissage serré et robuste.",
        "Kilims Persans – 18e-20e siècles : Tissage plat, motifs géométriques et abstraits, couleurs naturelles.",
        "Tapis Marocains (Boucherouite et Azilal) – 20e siècle : Styles artisanaux uniques, influences berbères, motifs symboliques.",
        "Tapis Indiens (Moghols) – 16e-17e siècles : Motifs floraux complexes, utilisation de la soie et de la laine, influence persane.",
        "Tapis de Chine (Pékin) – 17e-19e siècles : Motifs floraux et végétaux, influence asiatique, qualité de fabrication fine.",
    ];

    return (
        <CategoryPage
            title="Tapisserie"
            image={tapestryImage}
            description="En tant qu'expert antiquaire, je me spécialise dans l'acquisition de tapis anciens, qu'ils soient persans, turcs, marocains ou encore des kilims géométriques. Je suis à votre disposition pour évaluer et valoriser ces pièces uniques. Chaque tapis ancien est une œuvre d'art, reflet du savoir-faire des artisans et de l'héritage culturel des régions d'origine."
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default TapisseriePage;
